{
  "cms.schedule.title": "Ajastettu julkaisu",
  "cms.schedule.description": "Valitse alku- ja/tai loppuajankohta — sisältö julkaistaan ja poistetaan julkaisusta automaattisesti valittuina hetkinä.",
  "cms.schedule.windowLabel": "Julkaistaan",
  "cms.schedule.endWindowLabel": "Poistetaan julkaisusta",
  "cms.schedule.datePlaceholder": "Valitse päivä",
  "cms.schedule.clear": "Tyhjennä",
  "cms.schedule.submit": "Ajasta",
  "cms.schedule.reschedule": "Siirrä ajastusta",
  "cms.schedule.cancel": "Peru ajastus",
  "cms.schedule.pending": "Ajastettu julkaistavaksi:",
  "cms.schedule.endPending": "Ajastettu poistettavaksi julkaisusta:",
  "cms.schedule.locked": "Tämä ajastus on tallennettu. Voit muuttaa sitä sivun muokkausnäkymässä.",
  "cms.schedule.error.past": "Ajastusaika on menneisyydessä. Valitse tuleva ajankohta.",
  "cms.schedule.error.exists": "Tälle sisällölle on jo ajastus. Siirrä tai peru se ensin.",
  "cms.schedule.error.noPending": "Ajastusta ei löytynyt.",
  "cms.schedule.error.windowInverted": "Julkaisusta poistamisen on tapahduttava julkaisun jälkeen.",
  "cms.schedule.error.generic": "Ajastus epäonnistui. Yritä uudelleen.",
  "cms.schedule.error.load": "Ajastusten lataus epäonnistui. Yritä uudelleen.",
  "cms.schedule.error.afterContentSave": "Sisältö tallennettiin, mutta ajastusta ei voitu tallentaa. Korjaa ja tallenna uudelleen.",
  "cms.schedule.calendar.month.1": "tammikuu",
  "cms.schedule.calendar.month.2": "helmikuu",
  "cms.schedule.calendar.month.3": "maaliskuu",
  "cms.schedule.calendar.month.4": "huhtikuu",
  "cms.schedule.calendar.month.5": "toukokuu",
  "cms.schedule.calendar.month.6": "kesäkuu",
  "cms.schedule.calendar.month.7": "heinäkuu",
  "cms.schedule.calendar.month.8": "elokuu",
  "cms.schedule.calendar.month.9": "syyskuu",
  "cms.schedule.calendar.month.10": "lokakuu",
  "cms.schedule.calendar.month.11": "marraskuu",
  "cms.schedule.calendar.month.12": "joulukuu",
  "cms.schedule.calendar.weekdays": "ma ti ke to pe la su",
  "cms.schedule.calendar.previousMonth": "Edellinen kuukausi",
  "cms.schedule.calendar.nextMonth": "Seuraava kuukausi"
}
